import React from 'react';
import { Link } from 'react-router-dom';
import './LabourPricing.css';
import Footer4 from './footer4';
import Navbar8 from './navbar8';

const LabourPricing = () => {
    return (
      <>
        <Navbar8 />
        <div className="labour-pricing-container">
            <h1 className="pricing-title">Free Subscription for Labours</h1>
            
            <div className="pricing-cards">
                {/* Card 1 */}
                <div className="card">
                    <div className="card-icon">🔍</div>
                    <h2>Browse Jobs</h2>
                    <p>Access unlimited job listings without any cost.</p>
                </div>

                {/* Card 2 */}
                <div className="card">
                    <div className="card-icon">✅</div>
                    <h2>Instant Application</h2>
                    <p>Apply for jobs with just one click.</p>
                </div>

                {/* Card 3 */}
                <div className="card">
                    <div className="card-icon">📈</div>
                    <h2>Track Attendance</h2>
                    <p>Keep track of your job attendance in real time.</p>
                </div>
            </div>

            <div className="cta-section">
                <h2>Start Your Journey for Free!</h2>
            </div>
        </div>
        <Footer4 />
      </>
    );
};

export default LabourPricing;
